import { GROUP_IDS } from '@demeter/lib/constants/group-ids';

export enum NavBarItemType {
	BASE,
	DROPDOWN,
	ACTION
}

export interface NavBarConfig {
	type: NavBarItemType;
	label: string;
	route?: string;
	children?: NavBarConfig[];
	/**
	 * Optional: Array of roles/groups required to see this nav item.
	 * If not provided, item is visible to all authenticated users.
	 * If provided, user must have at least one of the specified roles.
	 */
	requiredRoles?: string[];
	action?: 'settings';
}

export const NAV_BAR_CONFIG: NavBarConfig[] = [
	{
		type: NavBarItemType.DROPDOWN,
		label: 'Reports',
		route: '#',
		children: [
			{
				type: NavBarItemType.BASE,
				label: 'Intraday Highs/Lows',
				route: '/reports/intraday'
			},
			{
				type: NavBarItemType.BASE,
				label: 'Fund Statistics',
				route: '/reports/fund-stats'
			},
			{
				type: NavBarItemType.BASE,
				label: 'Fund Accuracy',
				route: '/reports/fund-accuracy'
			}
		]
	},
	{
		type: NavBarItemType.DROPDOWN,
		label: 'Tools',
		route: '#',
		children: [
			{
				type: NavBarItemType.BASE,
				label: 'Command Center',
				route: '/tools/command-center',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Signal Audit',
				route: '/tools/signal-audit',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Price History',
				route: '/tools/price-history'
			},
			{
				type: NavBarItemType.BASE,
				label: 'Signal Overrides',
				route: '/tools/override',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Equity Adjustments',
				route: '/tools/equity-adjustments',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Configuration',
				route: '/tools/config',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Rebalance',
				route: '/tools/rebalance',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Execution Plans',
				route: '/tools/plans',
				requiredRoles: [GROUP_IDS.ADMIN]
			}
		]
	},
	{
		type: NavBarItemType.DROPDOWN,
		label: 'Funds',
		route: '#',
		children: [
			{
				type: NavBarItemType.BASE,
				label: 'All Funds',
				route: '/funds',
				requiredRoles: [GROUP_IDS.ADMIN]
			},
			{
				type: NavBarItemType.BASE,
				label: 'Transactions',
				route: '/transactions',
				requiredRoles: [GROUP_IDS.ADMIN]
			}
		]
	},
	{
		type: NavBarItemType.BASE,
		label: 'Health',
		route: '/health'
	},
	{
		type: NavBarItemType.ACTION,
		label: 'Settings',
		action: 'settings'
	}
];
